class Profile {
  private static profileMap: Map<number, { [key: string]: any }> = new Map();
  private static namespace = "_profile_";
  // TODO
  // public static hasKey(): boolean {
  //   return false
  // }
  public static getProfileByKey(userID: number, key: string) {
    Profile.ensure();
    const profile = Profile.profileMap.get(userID);
    if (profile) {
      return profile[key];
    }
    return null;
  }

  public static setProfile(userID: number, key: string, value: any) {
    const profile = Profile.profileMap.get(userID);
    if (profile) {
      profile[key] = value;
    } else {
      Profile.profileMap.set(userID, { [key]: value });
    }
    Profile.syncToStorage();
  }
  private static syncToStorage() {
    window.localStorage.setItem(
      Profile.namespace,
      JSON.stringify(Array.from(Profile.profileMap.entries()))
    );
  }
  private static ensure() {
    if (Profile.profileMap.size < 1) {
      const profile = window.localStorage.getItem(Profile.namespace);
      if (profile) {
        Profile.profileMap = new Map(JSON.parse(profile));
      }
      // NOTE: ensure
      Profile.profileMap.set(-1, { __internal__: "hasInitiated" });
    }
  }
}

export default Profile;
